import { createTheme } from "@mui/material/styles";

// Warm "archive paper" palette with a deep forest green taken from the
// society's tree emblem. Headings use a serif to give the historical source
// material some character; body text stays in Roboto for legibility.
const INK = "#1f2a24";
const GREEN = "#2f5d4a";
const PAPER = "#f6f3ec";

const theme = createTheme({
  palette: {
    primary: { main: GREEN, contrastText: "#fff" },
    secondary: { main: "#8a6a3b" },
    background: { default: PAPER, paper: "#ffffff" },
    text: { primary: INK, secondary: "#5b625d" },
    divider: "#e4ded1",
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Roboto", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h1: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 600 },
    h2: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 600 },
    h3: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 600 },
    h4: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 600 },
    h5: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 600 },
    h6: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 600 },
    overline: { fontWeight: 600, letterSpacing: "0.08em" },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8, paddingInline: 18 } },
    },
    MuiTextField: {
      defaultProps: { size: "small", fullWidth: true },
    },
    MuiOutlinedInput: {
      styleOverrides: { root: { backgroundColor: "#fff" } },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: { borderColor: "#e4ded1" },
      },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 14 } },
    },
  },
});

export default theme;
